import { Box, SxProps, Theme } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

interface BookingFormCardProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  [key: string]: any;
}

const BookingFormCardStyle = styled(Box)(({ theme }: any) => ({
  background: theme.palette.white[60],
  border: `1px solid ${theme.palette.white[70]}`,
  borderRadius: 16,
  width: '100%',
  marginTop: theme.spacing(1),
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    minWidth: '100%',
    paddingBlock: theme.spacing(2),
  },
}));

const BookingFormCard: React.FC<BookingFormCardProps> = ({ children, sx = {}, ...props }) => (
  <BookingFormCardStyle>
    <Box
      sx={sx}
      {...props}
    >
      {children}
    </Box>
  </BookingFormCardStyle >
);

export default BookingFormCard;